/* Снимките на продуктите стоят в Cloudinary в пълния си размер — някои са
   над 6 MB, направо от телефона, а на страницата се показват широки 200px.
   Затова началната страница тежеше 23 MB и на мобилни данни се зареждаше
   за 18 секунди.

   Cloudinary връща смалена снимка в по-лек формат (WebP/AVIF), ако в адреса
   след /image/upload/ се сложат трансформации. Тук се добавят само за
   снимките, които се показват на страницата. Адресите за Google и Facebook
   (og:image, JSON-LD) остават оригиналните — там трябва пълното качество.

   Същото правило има и в scripts/site-data.mjs (cdnImage) за статичните
   страници — сменяш ли едното, смени и другото. */

const UPLOAD = '/image/upload/';

const isCloudinary = url =>
  typeof url === 'string' && url.includes('res.cloudinary.com') && url.includes(UPLOAD);

/**
 * @param {string} url  оригиналният адрес от Firestore
 * @param {{w?: number, h?: number}} size
 *   само w → смалява до тази ширина, без изрязване (целият продукт се вижда);
 *   w и h  → изрязва до точно този размер около най-важното в снимката (g_auto).
 */
export function cdnImage(url, { w, h } = {}) {
  if (!isCloudinary(url)) return url;
  const [head, tail] = url.split(UPLOAD);
  // Адрес, който вече носи трансформация, се оставя както е.
  if (/^[a-z]{1,3}_[^/]*\//.test(tail)) return url;
  const t = ['f_auto', 'q_auto'];
  if (w && h) t.push('c_fill', 'g_auto', `w_${w}`, `h_${h}`);
  else if (w) t.push('c_limit', `w_${w}`);
  return `${head}${UPLOAD}${t.join(',')}/${tail}`;
}

/** srcset за няколко ширини; ratio = височина / ширина при изрязване. */
export function cdnSrcSet(url, widths, ratio) {
  if (!isCloudinary(url)) return undefined;
  return widths
    .map(w => `${cdnImage(url, ratio ? { w, h: Math.round(w * ratio) } : { w })} ${w}w`)
    .join(', ');
}
